import { safeWindow } from 'frontend/utils/window';

export function nativeBridgeIsPresent(): boolean {
  const window = safeWindow();
  if (!window) {
    return false;
  }

  // Mobile browsers like Chrome on iOS also have a webkit object on window, so
  // we also do a sanity check against the user agent here.
  const userAgent = navigator.userAgent;
  if (!userAgent.includes('brilliant-')) {
    return false;
  }

  const castedWindow = window as any;
  return !!(castedWindow.Android || castedWindow.webkit);
}

export function sendMessageAcrossNativeBridge(eventName: string, data?: any) {
  const window = safeWindow();
  if (!window) {
    return;
  }

  const castedWindow = window as any;
  if (castedWindow.Android) {
    castedWindow.Android.send(eventName, JSON.stringify(data));
  } else if (castedWindow.webkit) {
    castedWindow.webkit.messageHandlers?.main?.postMessage({
      event: eventName,
      data: JSON.stringify(data),
    });
  }
}
